// Maps the typed failure reason from /auth/microsoft/callback (and from the
// session exchange) to copy written for whoever is trying to sign in.
// Mirrors googleSignInErrorCopy.ts's split: the technical detail (which phase
// failed, Microsoft's response) lives in the API logs, not here.
const MICROSOFT_SIGN_IN_ERROR_COPY: Record<string, string> = {
  missing_params: 'Microsoft didn\'t send back what Zeph needed. Please try signing in again.',
  access_denied: 'Sign-in was cancelled. You can try again whenever you\'re ready.',
  microsoft_token_exchange_failed: 'Microsoft couldn\'t complete the sign-in. Please try again.',
  microsoft_token_invalid: 'Zeph couldn\'t verify your Microsoft identity. Please try again.',
  microsoft_profile_incomplete: 'Zeph couldn\'t read your Microsoft account details. Please try again.',
  microsoft_email_conflict: 'An account with this email already exists. Sign in with your password instead, or contact support to link Microsoft sign-in.',
  oauth_state_expired: 'That took too long, so Zeph stopped the sign-in for safety. Please try again.',
  invalid_state: 'That sign-in link isn\'t valid anymore. Please start again.',
  account_suspended: 'This account has been suspended. Contact your workspace admin.',
  handoff_code_invalid: 'This sign-in link has expired or was already used. Please sign in again.',
}

const FALLBACK = 'Something went wrong signing in with Microsoft. Please try again.'

export function microsoftSignInErrorCopy(reason: string | null): string {
  if (!reason) return FALLBACK
  return MICROSOFT_SIGN_IN_ERROR_COPY[reason] ?? FALLBACK
}
